import { render, staticRenderFns } from "./MessListMessageTable.vue?vue&type=template&id=4da636bd&scoped=true&"
import script from "./MessListMessageTable.vue?vue&type=script&lang=js&"
export * from "./MessListMessageTable.vue?vue&type=script&lang=js&"
import style0 from "./MessListMessageTable.vue?vue&type=style&index=0&id=4da636bd&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da636bd",
  null
  
)

export default component.exports